var pug = require("!../../../../pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (links, options) {let btnClass = 'btn btn-outline-primary';
let renderSpan = true;

// iterate options
;(function(){
  var $$obj = options;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var option = $$obj[pug_index0];
// iterate links[option]
;(function(){
  var $$obj = links[option];
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var link = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv class=\"core-fv__download-item\"\u003E";
if (renderSpan) {
pug_html = pug_html + "\u003Cspan\u003E" + (null == (pug_interp = link.label) ? "" : pug_interp) + " " + (pug.escape(null == (pug_interp = link.label.length > 4 ? '' : 'file') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Ca" + (pug.attr("class", pug.classes([btnClass], [true]), false, true)+pug.attr("href", link.href, true, true)+pug.attr("download", `${link.title} ${link.ext}`, true, true)) + "\u003EDownload  " + (null == (pug_interp = link.label) ? "" : pug_interp) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var link = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv class=\"core-fv__download-item\"\u003E";
if (renderSpan) {
pug_html = pug_html + "\u003Cspan\u003E" + (null == (pug_interp = link.label) ? "" : pug_interp) + " " + (pug.escape(null == (pug_interp = link.label.length > 4 ? '' : 'file') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Ca" + (pug.attr("class", pug.classes([btnClass], [true]), false, true)+pug.attr("href", link.href, true, true)+pug.attr("download", `${link.title} ${link.ext}`, true, true)) + "\u003EDownload  " + (null == (pug_interp = link.label) ? "" : pug_interp) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var option = $$obj[pug_index0];
// iterate links[option]
;(function(){
  var $$obj = links[option];
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var link = $$obj[pug_index2];
pug_html = pug_html + "\u003Cdiv class=\"core-fv__download-item\"\u003E";
if (renderSpan) {
pug_html = pug_html + "\u003Cspan\u003E" + (null == (pug_interp = link.label) ? "" : pug_interp) + " " + (pug.escape(null == (pug_interp = link.label.length > 4 ? '' : 'file') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Ca" + (pug.attr("class", pug.classes([btnClass], [true]), false, true)+pug.attr("href", link.href, true, true)+pug.attr("download", `${link.title} ${link.ext}`, true, true)) + "\u003EDownload  " + (null == (pug_interp = link.label) ? "" : pug_interp) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var link = $$obj[pug_index2];
pug_html = pug_html + "\u003Cdiv class=\"core-fv__download-item\"\u003E";
if (renderSpan) {
pug_html = pug_html + "\u003Cspan\u003E" + (null == (pug_interp = link.label) ? "" : pug_interp) + " " + (pug.escape(null == (pug_interp = link.label.length > 4 ? '' : 'file') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Ca" + (pug.attr("class", pug.classes([btnClass], [true]), false, true)+pug.attr("href", link.href, true, true)+pug.attr("download", `${link.title} ${link.ext}`, true, true)) + "\u003EDownload  " + (null == (pug_interp = link.label) ? "" : pug_interp) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

    }
  }
}).call(this);
}.call(this,"links" in locals_for_with?locals_for_with.links:typeof links!=="undefined"?links:undefined,"options" in locals_for_with?locals_for_with.options:typeof options!=="undefined"?options:undefined));;return pug_html;};
module.exports = template;